import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { StorageUtils } from 'app/utils/storage-utils';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private authService: AuthService, private router: Router, private storage: StorageUtils) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const isAuth = this.authService.isAuthenticated();
        if (!isAuth) {
            this.router.navigate(['/pages/login']);
        } else {
            this.checkRoute(state.url)
            return true;
        }
    }

    checkRoute(url: string) {
        const adminRoutes = ['/workspace/main', '/task/listall', '/company/listCustomer', '/company/listPartner', '/dashboard/invoicing', '/userb/list', '/userbgroup/list']
        if (adminRoutes.includes(url) && this.storage.getLoggedUser().type != "CONTAZZ") {
            this.router.navigate([this.storage.getUrlHome() ?? '/pages/login']);
        }
    }
}
